import {Options, useToasts} from 'react-toast-notifications';
import {Error} from '../api/generated';
import {useCallback, useMemo} from 'react';

type MessageTypes = 'success' | 'error' | 'info' | 'warning';

const defaultOptions = {
  autoDismiss: true,
  autoDismissTimeout: 5000,
  pauseOnHover: true,
};

export function useNotification() {
  const {addToast} = useToasts();

  type AddToast = Parameters<typeof addToast>;

  const createMessageType = useCallback(
    (type: MessageTypes) =>
      (
        message: string | React.ReactNode,
        options?: Partial<Options>,
        callback?: AddToast[2]
      ) => {
        addToast(
          message,
          {
            appearance: type,
            ...defaultOptions,
            ...(options || {}),
          },
          callback
        );
      },
    [addToast]
  );

  const notifiers = useMemo(
    () => ({
      success: createMessageType('success'),
      error: createMessageType('error'),
      info: createMessageType('info'),
      warning: createMessageType('warning'),
    }),
    [createMessageType]
  );

  return useMemo(
    () => ({
      ...notifiers,
      errors: (errors: Error[]) =>
        notifiers.error(errors.map((x) => x.errorMessage).join(' ')),
    }),
    [notifiers]
  );
}
